<template>
  <div>
    <div class="tab-cont prevMatch" v-if="filterList.length > 0">
      <div v-for="(item, index) in filterList" :key="index"
           class="matchBox line" :class="{ticketing: item.type}">
        <!-- !item.isEnd → item.audience === 0 -->
        <div class="bgLogo" :class="{hidden: item.audience === 0}">
          <div class="bannerTitle">
            <img v-if="item.league_name !== 'kleague'" :src="ImageSrc()" alt="banner_img" height="30">
            <img v-else src="@/assets/img/web/kleague_ico.png" alt="banner_img" width="80">
          </div>
          <div class="matchBox">
            <div class="info pc">
              <div class="bannerTitle">
                <img v-if="item.league_name !== 'kleague'" :src="ImageSrc()" alt="banner_img" height="30">
                <img v-else src="@/assets/img/web/kleague_ico.png" alt="banner_img" width="80">
              </div>
              <div class="stadium">{{ item.game_date }}<span>({{ item.game_yoil }}요일)</span></div>
              <div class="date">{{ item.game_time }}</div>
              <div class="field">
                {{ item.field_name }}
                <img src="@/assets/img/icon/icon_map.png" alt="" width="12">
              </div>
            </div>
            <div>
              <div class="game" :class="{hidden: (item.audience !== 0 && item.league_name !== 'kleague')}">
                <div class="emblem">
                  <img :src="getEmblem(item.home_team)" alt="">
                  <p>{{ item.home_team_name }}</p>
                </div>
                <!-- !item.isEnd → item.audience === 0 -->
                <div class="score home" :class="{active: item.home_team === 'K07', hidden: item.audience === 0}">{{ item.home_team_goal }}</div>
                <div class="vs">
                  <p class="title">VS</p>
                  <p class="place">{{ item.matchType }}</p>
                </div>
                <!-- !item.isEnd → item.audience === 0 -->
                <div class="score away" :class="{active: item.away_team === 'K07', hidden: item.audience === 0}">{{ item.away_team_goal }}</div>
                <div class="emblem">
                  <img :src="getEmblem(item.away_team)" alt="">
                  <p>{{ item.away_team_name }}</p>
                </div>
              </div>
              <div class="info">
                <div class="stadium">{{ item.game_date }}</div>
                <div class="date">{{ item.game_time }}</div>
                <div class="field">
                  {{ item.field_name }}
                  <img src="@/assets/img/icon/icon_map.png" alt="" width="12">
                </div>
              </div>

              <!-- !item.isEnd → item.audience === 0 -->
              <div v-if="item.audience === 0" class="btnBox reserve">
                <a v-if="item.matchType === '홈'" href="/ticket/reservations" class="slideLink">예매하기</a>
                <a v-else href="https://www.kleague.com/schedule.do?leagueId=2" target="_blank" class="slideLink black">예매하기</a>
              </div>
              <!--v-else-if="item.audience !== 0 && item.league_name === 'kleague'"-->
              <div v-else-if="item.audience !== 0" class="btnBox">
                <router-link v-if="item.league_name === 'kleague'" :to="{name: 'matchDetail', params: { id: item.detail, item: item }}">
                  <a href="javascript:void(0)" class="record">경기기록</a>
                </router-link>
                <router-link v-if="item.highlight && item.league_name === 'kleague'" :to="{name: 'matchDetail', params: { id: item.detail, item: item }, query: {tab: 2}}">
                  <a href="javascript:void(0)" class="highlight">하이라이트</a>
                </router-link>
                <a v-else-if="item.highlight && item.league_name === 'facup'" :href="item.highlight" target="_blank" class="highlight">하이라이트</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tab-cont prevMatch noData" v-else>
      등록된 경기일정이 없습니다.
    </div>
  </div>
</template>

<script>
import {getEmblem} from '@/lib';

export default {
  name: 'MatchResults',
  props: {
    list: Array,
    current: Number,
    slideYear: String
  },
  data() {
    return {
      filterList: [],
      league_icon: '',
    }
  },
  watch: {
    list: {
      handler: function () {
        this.filterList = this.list;
        this.currentChange();
      }
    },
    current: {
      handler: function () {
        this.currentChange();
      }
    }
  },
  methods: {
    getEmblem,
    currentChange() {
      if(this.current === 0) {
        this.filterList = this.list;
      } else {
        this.filterList = this.list.filter(item => item.league_idx === this.current);
      }
    },
    ImageSrc() {
      if(Number(this.slideYear) <= 2023) {
        this.league_icon = 'facup_ico.png';
      } else if(Number(this.slideYear) > 2023 && Number(this.slideYear) < 2025) {
        this.league_icon = 'jdfc_koreacup_2024.png';
      } else {
        this.league_icon = 'ico_facup.png';
      }

      return require('@/assets/img/web/' + this.league_icon);
    }
  }
}
</script>
<style scoped>
.noData {
  text-align: center;
  padding: 50px 0 100px;
}
.tab-cont .matchBox.line .slideLink.black {
  background-color: #000;
  color: #fff;
}
.prevMatch .matchBox .bgLogo .game .score.home.hidden,
.prevMatch .matchBox .bgLogo .game .score.away.hidden {
  width: 20px;
  margin: 0 18px;
}
.prevMatch .matchBox .btnBox.reserve a {
  position: relative;
}
.prevMatch .matchBox .bannerTitle {
  color: #000;
  font-size: 16px;
  font-weight: 700;
}
</style>
